<template>
  <div>
    <Navbar />

    <section class="time-of-damage">
      <Header />
      <damage-claim />
      <how-to-get-service />
      <!-- <app-warning-box class="mx-auto mt-5" /> -->
      <Questions />
      <damage-support />
      <frequently-asked-questions
        class="mt-16"
        :faqTitle="faqTitle"
        :faqTitleDesc="faqTitleDesc"
        :fromBackend="true"
      />
      <!-- <app-warning-box class="mx-auto mt-16" /> -->
    </section>
    <Footer />
  </div>
</template>

<script>
import Navbar from '@/component/navbar/Navbar'
import Header from '@/views/time-of-damage/Header'
import damageClaim from '@/views/time-of-damage/DamageClaim'
import howToGetService from '@/views/time-of-damage/HowToGetService'
// import appWarningBox from '@/component/warning-box/AppWarningBox'
import Questions from '@/views/time-of-damage/Questions'
import frequentlyAskedQuestions from '@/component/expansional-question-panel/AppQuestionPanel'
import damageSupport from '@/views/time-of-damage/DamageSupport'
import Footer from '@/component/footer/Footer'

export default {
  metaInfo: {
    title: 'Sigorta Hasar Anında | Alokasko.com',
    meta: [
      {
        name: 'description',
        content:
          'Sigorta hakkında merak ettiğiniz tüm soru ve cevaplara Alokasko.com sıkça sorulan sorular sayfamızdan ulaşabilirsiniz. - Merak ettiğiniz tüm detaylar.'
      }
    ]
  },
  head: {
    link: [
      { rel: 'canonical', href: 'https://www.alokasko.com/hasar-aninda' }
    ]
  },
  name: 'TimeOfDamage',
  components: {
    Navbar,
    Header,
    damageClaim,
    howToGetService,
    // appWarningBox,
    Questions,
    frequentlyAskedQuestions,
    damageSupport,
    Footer
  },
  data () {
    return {
      faqTitle: 'Hasar Hakkında Merak Edilenler ',
      faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.'
    }
  }
}
</script>
<style lang="scss">
@import '@/css/app.scss';
</style>
